import React, { createContext, useContext, useEffect, useState } from 'react';

import AlertSucess from '../components/alert/Sucess_alert';
import AlertError from '../components/alert/Error_alert';

// Create the context
const AlertContext = createContext();

// Create a custom hook to use the context
export const useAlertContext = () => {
    return useContext(AlertContext);
};

// Create a provider component
export const AlertProvider = ({ children }) => {

    const [openSucess, setOpenSucess] = useState(false)
    const [openFail, setOpenFail] = useState(false)
    const [messageSucess, setMessageSucess] = useState('')
    const [messageFail, setMessageFail] = useState('')


    useEffect(()=>{
        if(openSucess){
            setTimeout(()=>{
                setOpenSucess(false)
            },5000)
        }
    },[openSucess])

    useEffect(()=>{
        if(openFail){
            setTimeout(()=>{
                setOpenFail(false)
            },5000)
        }
    },[openFail])

    //success alert 

    const sucessAlert = (status, message) => {
        setOpenSucess(status)
        setMessageSucess(message)
    }

     //fail alert 

    const failAlert = (status, message) => {
        setOpenFail(status)
        setMessageFail(message)
    }

    return (
        <>
            <div className='absolute top-5 right-5 z-[1101]'>
                <AlertSucess 
                    openSucess={openSucess}
                    setOpenSucess={setOpenSucess}
                    message={messageSucess}
                />
                <AlertError
                    openFail={openFail}
                    setOpenFail={setOpenFail}
                    message={messageFail}
                />
            </div>
            <AlertContext.Provider value={{ sucessAlert, failAlert }}>
                {children}
            </AlertContext.Provider>
      </>
    );
};